/**
 * 호스트 URL 입니다.
 */
const BASE_URL = process.env.VUE_APP_API_HOST;

const LAT_LNG = {
    LOOP_ACCOUNT_AND_BRANCH: "lat-lng/loop/account-and-branch",
    LOOP_ACCOUNT_AND_BRANCH_RESET: "lat-lng/loop/account-and-branch-reset",
};

const DASHBOARD = {
    SUMMARY: 'dashboard/ops/summary',
    RANK: 'dashboard/ops/rank',
}

const MEMBERSHIP = {
    LIST: "membership/list",
    APPROVE: "membership/approve",
    REAPPROVE: "membership/reapprove",
    GET_MIGRATION_DATA: 'migration/download/',
    DELETE_MIGRATION_DATA: 'migration/delete/',
    UPDATE_AUTO_STATUS: 'membership/{0}/{1}',
    UPDATE_INFO: 'membership/rentalcompany-info/update',
    STATS: 'membership/stats',
    GET_LAST_LOGIN: 'membership/last-login'
}

const ERP_ACCESS = {
    LIST: "erp-access/applications",
    APPROVE: "erp-access/applications/",
    REJECT: "erp-access/applications/",
    REINVITE: "erp-access/applications/",
}

const AUTH = {
    LOGIN: "auth/login",
}

const ADMIN_USER = {
    LIST: "user/list",
    GET: "user/detail",
    UPDATE: "user/update",
    REGISTER: "user/register",
};

const ADMIN_USER_PERMISSION = {
    LIST: "user/permission/list",
    BIND: "user/permission/bind",
    UNBIND: "user/permission/unbind",
};

const NOTICE = {
    LIST: "notice/list",
    GET: "notice/get",
    ADD: "notice/add",
    UPDATE: "notice/update",
    DELETE: "notice/delete",
};

const BOARD = {
    NOTICE: {
        ADD: "board/notice/add",
        LIST: "board/notice/list",
        DELETE: "board/notice/delete",
        UPDATE: "board/notice/update",
    },
    TYPE: {
        LIST: "board/type/list",
    }
}

const AI_MANAGE = {
    CALL_HISTORY_LIST: "ai-manage/call-history/list",
    FAVORITE_QUESTIONS_LIST: "ai-manage/favorite-questions/list",
    FAVORITE_QUESTIONS_REPLACE: "ai-manage/favorite-questions/replace",
    CREDIT_WALLET_LIST: "ai-manage/credit/wallet/list",
    CREDIT_LEDGER_LIST: "ai-manage/credit/ledger/list",
    CREDIT_TOPUP: "ai-manage/credit/topup",
    CREDIT_SUBSCRIPTION_CANCEL: "ai-manage/credit/subscription/cancel",
    CREDIT_POLICY_FIELD_UPDATE: "ai-manage/credit/policy/field/update",
    CREDIT_GLOBAL_POLICY_DETAIL: "ai-manage/credit/policy/global/detail",
    CREDIT_GLOBAL_POLICY_UPDATE: "ai-manage/credit/policy/global/update",
}

const CODE = {
    ALL_LANGUAGE: "code/all-language",
    LIST: "code/list",
    CREATE: "code/create",
    UPDATE: "code/update",
    DELETE: "code/delete",
};

const MULTILANGUAGE = {
    LIST: "multilanguage/list",
    ADD: "multilanguage/add",
    UPDATE: "multilanguage/update",
};

const MONITORING = {
    AGENT_VERSION_BY_COUNTRY: "monitoring/list/agent-version/country",
    AGENT_VERSION_BY_RENTALCOMPANY: "monitoring/list/agent-version/rentalcompany",
    AGENT_VERSION: "monitoring/list/agent-version",
    AGENT_VERSION_SIMPLE: "monitoring/list/agent-version-simple",
    AGENT_CYCLE_BY_COUNTRY: "monitoring/list/agent-cycle/country",
    AGENT_CYCLE_BY_RENTALCOMPANY: "monitoring/list/agent-cycle/rentalcompany",
    AGENT_CYCLE_BY_TYPE: "monitoring/list/agent-cycle/type",
    PRINTER_SEARCH_RULE: "monitoring/list/printer/search-rule",
    SUPPORTED_PRINTER_SERIES: "monitoring/list/supported-printer/series",
    SUPPORTED_PRINTER_SERIES_UPDATE: "monitoring/update/supported-printer/series",
    RENTALCOMPANY_LIST: "monitoring/list/rentalcompany",
    AGENT_FILE_UPLOAD: "monitoring/agent/file/upload",
    DEVICE_PRINTER_LIST:"monitoring/list/device-printer",
    PRINTER_UPDATE:'monitoring/printer/update',
    DEVICE_LIST:'monitoring/device/list', //장치 목록
    DEVICE_DETAIL:'monitoring/device', //장치 상세
    DEVICE_UPDATE:'monitoring/device/update',//장치목록에서 flag 컨트롤,
    SEARCHED_LIST: 'monitoring/searched/list',//검색된 연결된 프린트 목록
    SUPPLY_STATUS_OVERVIEW: 'monitoring/supply/status/overview',
    SUPPLY_STATUS_SUMMARY: 'monitoring/supply/status/summary',
    SUPPLY_STATUS_ASSET: 'monitoring/supply/status/asset',
    SUPPLY_USAGE_LIST: 'monitoring/supply/usage/list',
    SUPPLY_USAGE_TREND: 'monitoring/supply/usage/trend',
    SUPPLY_USAGE_BREAKDOWN: 'monitoring/supply/usage/breakdown',
    SUPPLY_USAGE_HISTORY: 'monitoring/supply/usage/history',
    SUPPLY_EFFICIENCY_OVERVIEW: 'monitoring/supply/efficiency/overview',
    SUPPLY_EFFICIENCY_RANKING: 'monitoring/supply/efficiency/ranking',
    SUPPLY_EFFICIENCY_CYCLES: 'monitoring/supply/efficiency/cycles',
    PRINT_VOLUME_SUMMARY: 'monitoring/print-volume/summary',
    PRINT_VOLUME_LIST: 'monitoring/print-volume/list',
    PRINT_VOLUME_TREND: 'monitoring/print-volume/trend',
    SUPPLY_PURCHASE_FORECAST: 'monitoring/supply/purchase-forecast',
    SUPPLY_REPLACE_PLAN_OVERVIEW: 'monitoring/supply/replace-plan/overview',
    SUPPLY_REPLACE_PLAN_LIST: 'monitoring/supply/replace-plan/list',
    SUPPLY_REPLACE_PLAN_SLOTS: 'monitoring/supply/replace-plan/slots',
    SUPPLY_STATUS_UNMAPPED: 'monitoring/supply/status/unmapped',
    SUPPLY_SUGGEST: 'monitoring/supply/suggest',
    SUPPLY_COMMON_PART: 'monitoring/supply/common-part',
    SUPPLY_COMMON_PART_DELETE: 'monitoring/supply/common-part/delete',
    SUPPLY_COMMON_PART_LIST: 'monitoring/supply/common-part/list',
    SUPPLY_COMMON_PART_WORKSPACE: 'monitoring/supply/common-part/workspace',
    PRINTER_DRIVER_LIST: 'monitoring/printer-driver/list',
    PRINTER_DRIVER_SAVE: 'monitoring/printer-driver',
    PRINTER_DRIVER_DELETE: 'monitoring/printer-driver/delete',
    PRINTER_DRIVER_REQUEST_LIST: 'monitoring/printer-driver-request/list',
    PRINTER_DRIVER_REQUEST_STATUS: 'monitoring/printer-driver-request/status',
};
/**
 * 장치목록 -> 장치 상세정보
 * @type {{CMD_LIST: string, CMD_INSERT: string}}
 */
const CMD = {
    CMD_INSERT: "cmd/insert", //명령어등록
    CMD_LIST: "cmd/list"//명령어조회
}

const SYSTEM_PERMISSION = {
    ALL_PERMISSION: "permission/list",
    ALL_PERMISSION_BY_SYSTEM: "permission/list/system",
    ALL_PERMISSION_BY_RENTALCOMPANY: "permission/list/rentalcompany",
    RESTORE: "permission/restore",
    DELETE: "permission/delete",
    DELETE_PERMANENTLY: "permission/delete-permanently",
    CREATE_SYSTEM_PERMISSION: "permission/create/system",
    CREATE_RENTALCOMPANY_PERMISSION: "permission/create/rentalcompany",
    UPDATE_PERMISSION: "permission/update",
};

const SYSTEM_PERMISSION_GROUP = {
    DETAIL: "permission/group/detail",
    LIST_BY_SYSTEM: "permission/group/list/system",
    LIST_BY_SYSTEM_FOR_OPTIONS: "permission/group/list/system/options",
    LIST_BY_RENTALCOMPANY: "permission/group/list/rentalcompany",
    CREATE_BY_SYSTEM: "permission/group/create/system",
    CREATE_BY_RENTALCOMPANY: "permission/group/create/rentalcompany",
    DELETE: "permission/group/delete",
};

const SYSTEM_PERMISSION_GROUP_ITEM = {
    LIST: "permission/group/item/list",
    BIND_BY_SYSTEM: "permission/group/item/bind/system",
    UNBIND_BY_SYSTEM: "permission/group/item/unbind/system",
    BIND_BY_RENTALCOMPANY: "permission/group/item/bind/rentalcompany",
    UNBIND_BY_RENTALCOMPANY: "permission/group/item/unbind/rentalcompany",
};

const CONFIG_RENTALCOMPANY = {
    ALL_CONFIG: "config/rentalcompany/list",
    CREATE: "config/rentalcompany/create",
    UPDATE: "config/rentalcompany/update",
    DELETE_BY_FLAG: "config/rentalcompany/delete/flag",
    DELETE_PERMANENTLY: "config/rentalcompany/delete/permanently",
    RESTORE_BY_FLAG: "config/rentalcompany/restore/flag",
};

const MANUAL = {
    LIST: "manual/list",
    CREATE: "manual/create",
    UPDATE: "manual/update",
    DELETE: "manual/delete",
    RESTORE: "manual/restore",
    DELETE_PERMANENTLY: "manual/delete-permanently",
    DETAIL: "manual/detail",
    ACTIVATE: "manual/activate",
    CLOSE: "manual/close",
}

const NEW_MANUAL = {
    LIST: 'manual-new/list',
    DETAIL:'manual-new/detail',
    INSERT:'manual-new/insert',
    UPDATE:'manual-new/update'
}

/** 모바일 메뉴얼 (tb_mobile_manual, /api/v1/mobile-manual) */
const MOBILE_MANUAL = {
    LIST: 'mobile-manual/list',
    DETAIL: 'mobile-manual/detail',
    INSERT: 'mobile-manual/insert',
    UPDATE: 'mobile-manual/update',
}


const MANUAL_ITEM = {
    LIST: "manual/item/list",
    CREATE: "manual/item/create",
    UPDATE: "manual/item/update",
    DELETE: "manual/item/delete",
    SEQUENCE: "manual/item/sequence",
    ACTIVATE: "manual/item/activate",
    CLOSE: "manual/item/close",
}


const MIGRATION = {
 INSERT: "migration/list/insert/",
 DELETE: "migration/all/delete/",
 CMS_INSERT: "migration/fms/list/insert",
 CONTRACT_INSERT: "migration/list/insert/item-contract/",
 TAX_INSERT: "migration/list/insert/tax/"
}

const FILE = {
    FILE2: "resource/file2",
}

const ACCOUNT = {
    LIST:"account/list"
}

const BATCH = {
    CHECK: "batch/check",
    CHECK_SUMMARY: "batch/check/summary",
    TAX_CHECK: "batch/check/tax",
    TAX_CHECK_SUMMARY: "batch/check/tax/summary",
    TAX_CHECK_AFTER: "batch/check/tax/after",
    TAX_CHECK_AFTER_SUMMARY: "batch/check/tax/after/summary",
    SAVEREASON:"batch/saveReason",
    REASON:"batch/reasonList",
    DELETE:"batch/deleteReason",
    MONTHLY:"batch/usage/check",
    MISSING_BILLING:"batch/missing-billing/check",
    MISSING_BILLING_SUMMARY:"batch/missing-billing/check/summary",
    DOUBLE_WITHDRAWAL:"batch/double-withdrawal/check",
    DOUBLE_WITHDRAWAL_SUMMARY: "batch/double-withdrawal/check/summary",

    FORCE_SUSPENSION: 'batch/force-suspension',
    FORCE_SUSPENSION_UPDATE: 'batch/force-suspension/update',
    BATCH_MANAGER: 'batch/batch-manager',
    BATCH_MANAGER_UPDATE: 'batch/batch-manager/force/update',

    MONTHLY_CHECK: "batch/check/monthly-usage",
    MONTHLY_CHECK_SUMMARY: "batch/check/monthly-usage/summary",
    PRINTER_USAGE: 'batch/check/printer/usage',
    PRINTER_USAGE_CORRECTION: 'batch/check/printer/usage/correction',
    MONTHLY_USAGE_CORRECTION: 'batch/check/monthly/usage/correction',

    PRINTER_USAGE_ERROR: "batch/check/printer-usage-error",
    PRINTER_USAGE_ERROR_CNT: "batch/check/printer-usage-error/cnt",
    MONTHLY_USAGE_FIND: "batch/check/find/monthly-usage",
}

const BILLING = {
    LIST :'billing/list'
}
const CMS= {
    List : 'cms/payment/list',
}
/**
 * 임대업체 그룹 api
 */
const RANTALCOMPANY_GROUP = {
    // 그룹 목록 조회
    LIST : 'rantalcompany/group/list',
    // 신규 그룹 추가
    ADD : 'rantalcompany/group/add',
    // 그룹 수정 처리
    UPDATE : 'rantalcompany/group/update',
    // 그룹 내 임대업체 목록 조회
    RENTALCOMPANY_LIST: 'rantalcompany/group/rentalcompanies',
    // 전체 임대업체 목록 조회
    RENTALCOMPANY_ALL_LIST: 'rantalcompany/group/rentalcompanies/all',
}

const AGENCY_MANAGER = {
    LIST : 'agency/manager/list',
    ADD : 'agency/manager/add',
    MODIFY: 'agency/manager/modify',
    COMPANY_LIST : 'agency/manager/company/list',
    ASSIGN : 'agency/manager/assign',
    UN_ASSIGN : 'agency/manager/un-assign',
}

const MPS_PLAN = {
    BASE_LIST: 'mps-plan/base/list',
    BASE_INS_OR_UPD: 'mps-plan/base/ins-or-upd',
    SUB_CODE_LIST: 'mps-plan/sub-code/list',
    RENTALCOMPANY_PLAN: 'mps-plan/rentalcompany',
    RENTALCOMPANY_PLAN_INSERT: 'mps-plan/rentalcompany/insert'
}

const CMS_MEMBER = {
    REGISTER: 'cms/member/register',
    REGISTER_AGREEMENT: 'cms/member/register/agreement',
    UPDATE: 'cms/member/update',
    RETRIEVE: 'cms/member',
    REFRESH: 'cms/member/refresh',
    DELETE: 'cms/member/delete',

    SIMPLE_REGISTER: 'cms/member/simple/register',
    SIMPLE_RETRIEVE: 'cms/member/simple/retrieve',
    SIMPLE_CANCEL: 'cms/member/simple/cancel',

    BANK_CODE: 'cms/member/bank-codes',
}

const MPS_USAGE = {
    REGISTER: 'mps-usage/register',
    LIST: 'mps-usage/list',
    SUMMARY: 'mps-usage/list/summary'
}

const MPS_BILLING = {
    REGISTER: 'mps-billing/register'
}
const USER_PERMISSION = {
    USER_CHECK: 'company/user/permission/check',
    GRANT_BANK: 'company/user/permission/grant',
    GRANT_BANK_UPDATE: 'company/user/permission/grant/update',
    REQUESTER: 'company/user/permission/selected',
    EMPLOYEES: 'company/user/permission/employees'
}
export default {
    DASHBOARD,
    ACCOUNT,
    BASE_URL,
    AUTH,
    MEMBERSHIP,
    ERP_ACCESS,
    BILLING,
    ADMIN_USER,
    ADMIN_USER_PERMISSION,
    NOTICE,
    CODE,
    MULTILANGUAGE,
    MONITORING,
    SYSTEM_PERMISSION,
    SYSTEM_PERMISSION_GROUP,
    SYSTEM_PERMISSION_GROUP_ITEM,
    CONFIG_RENTALCOMPANY,
    MANUAL,
    MANUAL_ITEM,
    LAT_LNG,
    BOARD,
    AI_MANAGE,
    MIGRATION,
    FILE,
    BATCH,
    NEW_MANUAL,
    MOBILE_MANUAL,
    CMD,
    CMS,
    RANTALCOMPANY_GROUP,
    AGENCY_MANAGER,
    MPS_PLAN,
    CMS_MEMBER,
    MPS_USAGE,
    MPS_BILLING,
    USER_PERMISSION,
}
